import api from 'services/api';

class OSSEstoqueService {
  /**
   * Buscar dados de OSS estoque com action específica
   * Faz requisição para a API Laravel que gerencia cache e N8N
   */
  async buscarDadosOSS(action, params = {}) {
    try {
      
      const response = await api.post('/n8n/estoque/oss-estoque', {
        action,
        empresa: params.empresa || 'MOV Fibra',
        data_inicio: params.data_inicio || new Date().toISOString().split('T')[0],
        data_fim: params.data_fim || new Date().toISOString().split('T')[0]
      });

      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar dados de OSS estoque:', error);
      throw error;
    }
  }

  /**
   * Buscar KPIs de OSS
   */
  async buscarKPIs(params = {}) {
    return this.buscarDadosOSS('kpis', params);
  }

  /**
   * Buscar OSS por dia
   */
  async buscarPorDia(params = {}) {
    return this.buscarDadosOSS('por_dia', params);
  }

  /**
   * Buscar OSS por diagnóstico
   */
  async buscarPorDiagnostico(params = {}) {
    return this.buscarDadosOSS('por_diagnostico', params);
  }

  /**
   * Buscar OSS por assunto
   */
  async buscarPorAssunto(params = {}) {
    return this.buscarDadosOSS('por_assunto', params);
  }

  /**
   * Buscar OSS por tempo
   */
  async buscarPorTempo(params = {}) {
    return this.buscarDadosOSS('por_tempo', params);
  }

  /**
   * Buscar OSS por técnico
   */
  async buscarPorTecnico(params = {}) {
    return this.buscarDadosOSS('por_tecnico', params);
  }

  /**
   * Buscar OSS por cidade
   */
  async buscarPorCidade(params = {}) {
    return this.buscarDadosOSS('por_cidade', params);
  }

  /**
   * Buscar OSS por bairro
   */
  async buscarPorBairro(params = {}) {
    return this.buscarDadosOSS('por_bairro', params);
  }

  /**
   * Buscar OSS por mês
   */
  async buscarPorMes(params = {}) {
    return this.buscarDadosOSS('por_mes', params);
  }

  /**
   * Buscar detalhamento de OSS
   */
  async buscarDetalhamento(params = {}) {
    return this.buscarDadosOSS('detalhamento', params);
  }

  /**
   * Buscar OSS não finalizadas
   */
  async buscarNaoFinalizadas(params = {}) {
    return this.buscarDadosOSS('nao_finalizada', params);
  }

  /**
   * Limpar cache de OSS estoque
   */
  async limparCache(empresa = 'MOV Fibra') {
    try {
      
      const response = await api.post('/n8n/estoque/limpar-cache', {
        empresa
      });

      return response.data;
    } catch (error) {
      console.error('❌ Erro ao limpar cache de OSS estoque:', error);
      throw error;
    }
  }
}

// Instância singleton
const ossEstoqueService = new OSSEstoqueService();

export default ossEstoqueService;

